module.exports = __webpack_public_path__ + "static/media/white-phone.e74d0f3e.svg";